import React from 'react';

import { Box, Text } from '@chakra-ui/react';

import { Alert } from '@firehydrant/design-system';

interface ComplianceWarningProps {
  variant?: 'alert' | 'warning' | 'info';
  showPolicyLink?: boolean;
}

export const ComplianceWarning = ({
  variant = 'warning',
}: ComplianceWarningProps) => {
  const alertStatus =
    variant === 'alert' ? 'alert' : variant === 'warning' ? 'warning' : 'info';

  return (
    <Alert variant={alertStatus} borderRadius="md" my="2">
      <Box>
        Your notification preferences do not meet the organization&apos;s policy
        requirements.
        {variant === 'alert' && (
          <Text mt="2" fontSize="sm">
            Please update your preferences to ensure you receive critical alerts
            on time.
          </Text>
        )}
      </Box>
    </Alert>
  );
};
